import * as React from 'react';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import { __t, applyTranslations } from 'utils/language';

import './report-download-actions.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./report-download-actions.i18n.json'));

type Props = {
  isAlreadyExpanded: boolean,
  isAlreadySelected: boolean,
  onToggleDisplaySelected: (a: boolean) => void,
  onSelectAll: () => void,
  onDeselectAll: () => void,
  onExpandAll: () => void,
  onCollapseAll: () => void
};

const Actions = {
  SELECT: 'select',
  DESELECT: 'deselect',
  COLLAPSE: 'collapse',
  EXPAND: 'expand'
};

function wrappedTabsUnderlinedCallback(callback: (a: string | undefined) => void) {
  return (event: SyntheticEvent<HTMLElement>) => {
    const target = event.currentTarget;
    const type = target.dataset.arg;

    callback(type);
  };
}

const ReportDownloadActions = (
  {
    isAlreadyExpanded,
    isAlreadySelected,
    onToggleDisplaySelected,
    onSelectAll,
    onDeselectAll,
    onExpandAll,
    onCollapseAll
  }: Props
): JSX.Element => {
  const [isDisplaySelectedOnly, setDisplaySelectedOnly] = React.useState(false);
  const [isAllSelected, setAllSelected] = React.useState(false);
  const [isAllExpanded, setAllExpanded] = React.useState(false);

  React.useLayoutEffect(() => {
    if (isAlreadySelected !== isAllSelected) {
      setAllSelected(isAlreadySelected);
    }
  }, [isAlreadySelected]);

  React.useLayoutEffect(() => {
    if (isAlreadyExpanded !== isAllExpanded) {
      setAllExpanded(isAlreadyExpanded);
    }
  }, [isAlreadyExpanded]);

  return (
    <section className="report-download-actions">
      <div className="report-download-actions__item">
        <TabsUnderlined
          items={[{
            isActive: false,
            handleClick: wrappedTabsUnderlinedCallback((type: string | undefined) => {
              const isSelect = type === Actions.SELECT;
              setAllSelected(isSelect);

              if (isSelect) {
                onSelectAll();
              } else {
                onDeselectAll();
              }
            }),
            handleClickArg: isAllSelected ? Actions.DESELECT : Actions.SELECT,
            label: isAllSelected
              ? __t('report_download_actions.deselect_all_label')
              : __t('report_download_actions.select_all_label')
          }]}
          size="small"
        />
      </div>
      <div className="report-download-actions__item">
        <TabsUnderlined
          items={[{
            isActive: false,
            handleClick: wrappedTabsUnderlinedCallback((type: string | undefined) => {
              const isExpand = type === Actions.EXPAND;
              setAllExpanded(isExpand);

              if (isExpand) {
                onExpandAll();
              } else {
                onCollapseAll();
              }
            }),
            handleClickArg: isAllExpanded ? Actions.COLLAPSE : Actions.EXPAND,
            label: isAllExpanded
              ? __t('report_download_actions.collapse_all_label')
              : __t('report_download_actions.expand_all_label')
          }]}
          size="small"
        />
      </div>
      <div className="report-download-actions__filter">
        <InputCheckbox
          id="deliverables-filter-states"
          name="deliverables-filter-states"
          label={__t('report_download_actions.display_selected_label')}
          checked={isDisplaySelectedOnly}
          value="show-selected"
          tooltipMessage={__t('report_download_actions.display_selected_tooltip')}
          onChange={(event) => {
            const isChecked = event.currentTarget.checked;
            setDisplaySelectedOnly(isChecked);
            onToggleDisplaySelected(isChecked);
          }}
        />
      </div>
    </section>
  );
};

export default ReportDownloadActions;
